export default __webpack_public_path__ + "static/media/BrainBreak cards54.2c190dcb.png";